<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xRRMbJ/tc-custom/9781446360224.jpg?1705233287952" alt="This image is the cover for the book Japanese Style, Quilt Essentials"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Japanese Style, Quilt Essentials
      </h1>
      <p class="bookDescription body article font2">
        <b>The renowned expert and author of <i>The Ultimate Sashiko Source Book</i> guides quilters through traditional Japanese techniques. </b><br/><br/>This collection of projects by Susan Briscoe really captures the essence of Japanese quilting style. It includes step-by-step instructions for creating Japanese style quilting projects including throws, cushions and quilts. The projects feature traditional Japanese techniques, designs and fabrics. Includes small, accessible projects such as coasters alongside full sized quilt instructions, as well as traditional Japanese quilting techniques such as sashiko.<br/><br/><b>Praise for Susan Briscoe</b><br/><br/>“Susan Briscoe writes with an obvious fondness for Japanese culture.” —<i>The Ardent Thread</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Briscoe
      </h2>
      
      <p class="authorDescription body article"><B>Susan Briscoe</B> studied Visual Art and Drama at the University College of Wales before moving to Japan to teach English. Here she became fascinated by Japanese fabrics and their patchwork and quilting techniques. She has succeeded in combining her design and needlework skills with a need for practical accessories in her job as a footpath officer. Susan now writes and designs for needlecraft magazines and teaches bag making and sashiko quilting. She has exhibited at UK national quilting shows as well as in Japan. Susan Briscoe lives in Wrexham, North Wales.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a2e8b172